
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from "lucide-react";

import './BackButton.css';

const BackButton = ({ text = "Back", onClick, className = "" }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1); 
    }
  };

  return (
    <button 
      className={`back-button ${className}`}
      onClick={handleClick}
      type="button"
    >
      <span className="back-arrow">←</span>
      {text}
    </button>
  );
};

export default BackButton;